import { getRequest, patchRequest } from 'utils/axios'

export const fetchSkills = (playerUuid, params = {}) => {
  const url = `/v2/players/${playerUuid}/skills`

  return getRequest(url, params)
}

export const updateSkillValue = (uuid, value) => {
  const url = `/v2/player-skills/${uuid}`

  return patchRequest(url, { value })
}

export const fetchPlayerStatistics = (playerUuid, params = {}) => {
  const url = `/v2/players/${playerUuid}/statistics`

  return getRequest(url, params)
}
